export default defineAppConfig({
  ui: {
    alert: {
      slots: {
        root: 'rounded-[0.75em] gap-2.5 p-5',
        title: 'text-black text-lg',
        description: 'text-black text-base',
        icon: 'size-6.5',
        wrapper: 'gap-3',
      },
      compoundVariants: [
        {
          color: 'success',
          variant: 'solid',
          class: {
            root: 'bg-green-20',
            icon: 'text-green-40',
          },
        },
        {
          color: 'info',
          variant: 'solid',
          class: {
            root: 'bg-blue-20',
            icon: 'text-[#01739f]',
          },
        },
        {
          color: 'error',
          variant: 'solid',
          class: {
            root: 'bg-[#fee0e3]',
            icon: 'text-red-30',
          },
        },
        {
          color: 'warning',
          variant: 'solid',
          class: {
            root: 'bg-yellow-20',
            icon: 'text-[#eab308]',
          },
        },
      ],
    },
    checkbox: {
      slots: {
        base: 'rounded-[3px] has-data-[state=checked]:bg-[var(--background,var(--color-seagreen-50))] has-data-[state=checked]:ring-[var(--background,var(--color-seagreen-50))]',
      },
    },
    icons: {
      menu: 'far:bars',
      close: 'far:xmark',
      check: 'fas:check',
      chevronDown: 'far:chevron-down',
      chevronUp: 'far:chevron-up',
      chevronLeft: 'far:chevron-left',
      chevronRight: 'far:chevron-right',
    },
    header: {
      slots: {
        root: 'bg-green-50 border-green-pop text-white',
      },
    },
    container: {
      base: '!px-(--ui-container-inline-padding,var(--spacing-s)) sm:!px-(--ui-container-inline-padding,var(--spacing-m)) max-w-[calc(var(--ui-container, 72rem)+calc(2*var(--ui-container-inline-padding)))]',
    },
    accordion: {
      slots: {
        root: 'text-base flex flex-col gap-3',
        item: 'border-none hover:contrast-90 px-4',
        trigger: 'text-base',
      },
    },
    toast: {
      slots: {
        root: 'rounded-[0.75rem]',
        title: 'text-black text-base font-medium',
        close: 'text-black',
        actions: '[&>button]:text-black',
      },
      variants: {
        color: {
          info: {
            root: 'bg-blue-20',
            icon: 'text-[#01739f]',
          },
          success: {
            root: 'bg-green-20',
            icon: 'text-green-40',
          },
          error: {
            root: 'bg-[#fee0e3]',
            icon: 'text-red-30',
          },
        },
      },
    },
  },
  icon: {
    size: '1.25em',
    mode: 'css',
    cssLayer: 'base',
  },
})
